import { Button, Divider, Form, Input, Modal } from "antd";
import { postApi } from "apis";
import { useState } from "react";
import { toastText } from "utils/utils";

const HotSpotChangeModal = (props: any) => {
  const { openAminPassModalForChangeWifi, setOpenAminPassModalForChangeWifi, deviceId } = props;

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(false);

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      if (!isPasswordValid) {
        const res = await postApi('/devices/validate-admin-pass', {
          deviceId,
          ...values,
        });

        if (res?.data?.data) {
          toastText(res?.data?.message, 'success');
          setIsPasswordValid(true);
        }
      }
      else{
        const res = await postApi('/devices/change-wifi', {
          deviceId,
          ...values,
        });

        if (res?.data?.data) {
          toastText(res?.data?.message, 'success');
          setOpenAminPassModalForChangeWifi(false);
          form.resetFields();
          setIsPasswordValid(false);
        }
      }
    } catch (err: any) {
      toastText(err?.response?.data?.message, 'error');
    } finally {
      setLoading(false);
      
    }
  };

  return (

    <Modal
      open={openAminPassModalForChangeWifi}
      onCancel={() => setOpenAminPassModalForChangeWifi(false)}
      footer={null}
      title={
        <div style={{ fontSize: 16, fontWeight: 600 }}>
          Change Hotspot
        </div>
      }
      style={{ paddingTop: 8, paddingBottom: 0 }}
    >
      <Divider />
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        {!isPasswordValid && (
          <Form.Item
            label="Admin Password"
            name="adminPassword"
            rules={[{ required: true, message: 'Please enter admin password' }]}
          >
            <Input.Password placeholder="Enter admin password" />
          </Form.Item>
        )}

        {isPasswordValid && (
          <>
            <Form.Item
              label="Wifi Ssid"
              name="wifiSsid"
              rules={[{ required: true, message: 'Wifi Ssid' }]}
            >
              <Input placeholder="Enter wifi ssid" />
            </Form.Item>

            <Form.Item
              label="Wifi Password"
              name="wifiPassword"
              rules={[{ required: true, message: 'Please enter wifi password' }]}
            >
              <Input.Password placeholder="Enter wifi password" />
            </Form.Item>
          </>
        )}

        <Form.Item style={{ marginTop: 24, textAlign: 'right' }}>
          <Button
            type="primary"
            htmlType="submit"
            size="middle"
            loading={loading}
            style={{ padding: '0 24px', fontWeight: 500 }}
          >
            {isPasswordValid ? 'Update Hotspot' : 'Validate Password'}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default HotSpotChangeModal